import {
  Component,
  OnInit,
  ChangeDetectorRef,
  AfterViewInit,
  ElementRef,
  ViewChild,
  NgZone,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { CmsBannerComponent, CmsService, OccConfig } from '@spartacus/core';
import { ContentService } from '../../spartacus/services/content.service';
import { SelectionModel } from '@angular/cdk/collections';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MaterialsUKService } from '../materialsuk-service';
import { combineLatest, map, Observable } from 'rxjs';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { codeValidation } from './code.validator';
import { RegistrationUkService } from '../../registration_uk/registration-uk.service';
import { CmsComponentData } from '@spartacus/storefront';
import { Router } from '@angular/router';
import JSZip from 'jszip';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import { HttpClient } from '@angular/common/http';
declare var clickToAddress:any;
@Component({
    selector: 'app-materialslanding',
    templateUrl: './materialslanding.component.html',
    styleUrl: './materialslanding.component.scss',
    standalone: false
})
export class MaterialslandingComponent implements OnInit, AfterViewInit {
  dataSourcemain: any = [];
  showinput: boolean = false;
  showbtnenabled: boolean = true;
  showmateriallanding: boolean = true;
  showreview: boolean = false;
  showthankyou: boolean = false;
  displayedColumnsmain: string[] = ['combined'];
  displayedColumns: string[] = [
    'checkbox',
    'shippingOrganizationName',
    'shippingAddressLine1',
    'col4',
  ];
  dataSource: any;
  submittedDataSource: any;
  selection = new SelectionModel<any>(true, []);
  data: any;
  submittedData: any;
  isLoading:boolean=false;
  displayAddressForm = false;
  displayMaterials = true;
  submitted = false;
  count:number=0;
  materialReviewList: any[] = [];
  isSubmitted = false;
  enableSubmit = false;
  showback = false;
  isUserLoggedIn: boolean = false;
  userInfo: any;
  selectedAccount: string = '';
  requestNumber: any;
  cc: any;
  digitalcheck:boolean=false;
  materailorder:any=[];
  materailgeneral:any=[];
  materailwholedata:any=[];
  materailhcp:any=[];
  materaildigital:any=[];
  materailtranslate:any=[];
  dataSourceorder:any;
  dataSourcegeneral:any;
  dataSourcehcp:any;
  dataSourcetranslate:any;
  dataSourcedigital:any;
  carouselImagesdata:any=[];
  rbavarible:any;
  downloaddigital:any=[]
  showcarousel:boolean=false
  materialcmsdata:any;
  bannerNode: Observable<any> = this.component.data$;
  materialblock:boolean=true
  startorderseason:string=""
  mybasketmaterial:any=[];
  hasdigital:boolean=false
  currentSlideIndex = 0;
  opendigital: boolean = false;
  selectedDigitalMaterial: any = null;
  digitalAgreeChecked: boolean = false;
  @ViewChild('generalSlider', { static: false }) generalSliderRef!: ElementRef<HTMLElement>;
  @ViewChild('generalPrev', { static: false }) generalPrevRef!: ElementRef<HTMLElement>;
  @ViewChild('generalNext', { static: false }) generalNextRef!: ElementRef<HTMLElement>;

  @ViewChild('hcpSlider', { static: false }) hcpSliderRef!: ElementRef<HTMLElement>;
  @ViewChild('hcpPrev', { static: false }) hcpPrevRef!: ElementRef<HTMLElement>;
  @ViewChild('hcpNext', { static: false }) hcpNextRef!: ElementRef<HTMLElement>;

  @ViewChild('digitalSlider', { static: false }) digitalSliderRef!: ElementRef<HTMLElement>;
  @ViewChild('digitalPrev', { static: false }) digitalPrevRef!: ElementRef<HTMLElement>;
  @ViewChild('digitalNext', { static: false }) digitalNextRef!: ElementRef<HTMLElement>;

  private generalSwiper?: Swiper;
  private hcpSwiper?: Swiper;
  private digitalSwiper?: Swiper;


  addressForm = new FormGroup({
    organizationName: new FormControl(''),
    address: new FormControl(''),
    line1: new FormControl('', [Validators.required]),
    city: new FormControl('', [
      Validators.required
    ]),
    code: new FormControl('', [Validators.required, codeValidation()]),
    country: new FormControl('', [
      Validators.required,
      Validators.pattern('^[a-zA-Z ]+$'),
    ]),
  });
  mergeobj: any = [];
  isAsmUser: boolean = false;
  constructor(
    private elRef: ElementRef,
    private http: HttpClient,
    private router: Router,
    public component: CmsComponentData<CmsBannerComponent>,
    protected config: OccConfig,
    private cmsService: CmsService,
    private cd: ChangeDetectorRef,
    private accessService: ContentService,
    private materialsUKService: MaterialsUKService,
    public userInfoService: UserInfoService,
    public registrationUkService: RegistrationUkService,
    private ngZone: NgZone
  ) {}

  ngOnInit(): void {
    this.materialsUKService.getmaterailblock().subscribe((data:any)=>{
      this.materialblock=data.materialsPrebookOrderExists;
      this.startorderseason=data.season
      this.cd.detectChanges();
    });
    this.bannerNode.subscribe(res => {
      this.materialcmsdata=res;
    });
    this.materialsUKService.getmaterailData().subscribe((data)=>{
      this.materailwholedata=data
      this.materailwholedata?.forEach((element:any) => {
        element.addbasket = false;
        element.quantity = null;
        element.onlydownload=false;
        element.maxqunatitynumber=Number(element.maxQty)
        
       if(element.tileType=="BUNDLE"){
        if(element.code=="BUNDLE_CODE_4"){
          element.onlydownload=true;
         }
        this.materailorder.push(element);
        this.cd.detectChanges();
       }else if(element.tileType=="GENERAL"){
        this.materailgeneral.push(element);
       } else if(element.tileType=="TRANSLATED"){
        this.materailtranslate.push(element);
       } else if(element.tileType=="DIGITAL_MATERIAL"){
        this.materaildigital.push(element);
       } else if(element.tileType=="HCP"){
        this.materailhcp.push(element);
       }  

      });

      this.materailorder.sort((a:any, b:any) => a?.sequenceNumber - b?.sequenceNumber);
      this.materailgeneral.sort((a:any, b:any) => a?.sequenceNumber - b?.sequenceNumber);
      this.materailtranslate.sort((a:any, b:any) => a?.sequenceNumber - b?.sequenceNumber);
      this.materaildigital.sort((a:any, b:any) => a?.sequenceNumber - b?.sequenceNumber);
      this.materailhcp.sort((a:any, b:any) => a?.sequenceNumber - b?.sequenceNumber);
      this.dataSourceorder=this.materailorder;
      this.dataSourcegeneral=this.materailgeneral;
      this.dataSourcetranslate=this.materailtranslate;
      this.dataSourcedigital=this.materaildigital;
      this.dataSourcehcp=this.materailhcp;
      this.rbavarible=localStorage.getItem('rbapermission');
      this.rbavarible=JSON.parse(this.rbavarible);
      this.cd.detectChanges();  
      //initalising the general hcp and digital slides    
      setTimeout(() => {
        this.initSliders();
      }, 0);

    })


    this.materialsUKService.checkUserLoggedIn();
        this.materialsUKService
          .getShippingLocationData()
          .subscribe((data: any) => {
            this.data = data?.materialsShipping;
            this.dataSource = new MatTableDataSource(data?.materialsShipping);
          });

        this.userInfoService.userLoggedIn$.subscribe((res) => {
          this.isUserLoggedIn = res;
          if (this.isUserLoggedIn) {
            this.userInfoService.getUserData().subscribe((res) => {
              if (res) {
                this.userInfo = res;

                localStorage.setItem('webEnabled', this.userInfo.webEnabled);
                this.selectedAccount = this.userInfo.orgUnit.uid;
              }
            });
          }
        });
      this.getsavematerial();
      this.isAsmUser = this.userInfoService.checkAsmUser();
  }

  //new code
  closeorder(link:string){
    if(link=='start-order'){
      this.router.navigateByUrl("/start-order?season="+this.startorderseason);
    }else{
    this.router.navigate(['/'+link]);
    }
    this.materialblock=true
  }
  animate(event:any){
    if(event.target.nodeName=='SPAN'){
     //const elem= this.elRef.nativeElement.parentElement(event);
     event.target.parentElement.classList.add("animateadd");
     setTimeout(() => {
      event.target.parentElement.classList.remove("animateadd");
      this.cd.detectChanges();
    }, 3000);
    }else if(event.target.nodeName=='svg' ){
      event.target.parentElement.parentElement.classList.add("animateadd");
      setTimeout(() => {
        event.target.parentElement.parentElement.classList.remove("animateadd");
        this.cd.detectChanges();
      }, 3000);
    }else if( event.target.nodeName=='path'){
      event.target.parentElement.parentElement.parentElement.classList.add("animateadd");
      setTimeout(() => {
        event.target.parentElement.parentElement.parentElement.classList.remove("animateadd");
        this.cd.detectChanges();
      }, 3000);
    } 
      else{
    event.target.classList.add("animateadd");
    
    setTimeout(() => {
      event.target.classList.remove("animateadd");
      this.cd.detectChanges();
    }, 3000);
  }
    this.cd.detectChanges();
  }
  handleonaddbasket(ele:any){
   
    ele.addbasket=true;
    if(ele.tileType=="BUNDLE"){
      const bundleaary = Object.entries(ele.bundleProducts);
      bundleaary.forEach((bundle:any)=>{
        this.materailwholedata?.forEach((element:any) => {
          if(bundle[0]==element.code){
            if(element.quantity<element.maxqunatitynumber && (element.quantity + Number(bundle[1])<=element.maxqunatitynumber)){            
              element.quantity=element.quantity + Number(bundle[1])
              const valueexist=this.mybasketmaterial.find((y:any) => y.code == element.code);
              if(!valueexist){
              this.mybasketmaterial.push(element);
              }
            }
          }
        });
      })
    }else{
    if(ele.quantity<ele.maxqunatitynumber){
    ele.quantity=ele.quantity+1
    const valueexist=this.mybasketmaterial.find((x:any) => x.code == ele.code);
    if(!valueexist){
    this.mybasketmaterial.push(ele);
    }
  }
  }
  this.savematerial(this.mybasketmaterial)
  this.enablecheckout();
    this.cd.detectChanges();
  }


  savematerial(basket:any){
    const productsList = basket.map((ele:any) => {
      return {
        materialID: ele.code,
        qty: ele.quantity,
      };
    });
    const selectedAddress = this.dataSource.data.filter(
      (ele: any) => ele.checked
    );
   
    const saverequestData = {
      productDetails: productsList,
      soldToID: this.selectedAccount,
    }  
    this.isLoading=true;
    this.materialsUKService.submitsaveMaterialData(saverequestData).subscribe((res:any)=>{
      this.isLoading=false;
      this.cd.detectChanges();
    }, (error) => {
      console.log('error: ', error);
      this.isLoading=false;
      this.cd.detectChanges();
    });
  }
  opencarousel(eleimg:any){
this.carouselImagesdata=eleimg;
this.showcarousel=true;
this.cd.detectChanges();
//initalising the popup carousel
setTimeout(() => {
    const carouselEl = document.getElementById('carouselmaterial');
    carouselEl?.addEventListener('slide.bs.carousel', (event: any) => {
      this.ngZone.run(() => {
        this.currentSlideIndex = event.to;
        this.cd.detectChanges();
      });
    });
  }, 0);
  }
  closecarousel(){
    this.carouselImagesdata=[]
this.showcarousel=false;
//resetting the slide index after closing the popup
this.currentSlideIndex = 0;
this.cd.detectChanges();
  }

  onvaluechange(event:any,ele:any){
   ele.quantity=Number(event?.target.value);
   this.savematerial(this.mybasketmaterial)
  }
  removematerial(material:any){
    material.addbasket=false
    material.quantity=null
    this.mybasketmaterial.forEach((x:any, index:number) => {
      if(x.code == material.code){
       this.mybasketmaterial.splice(index,1);
      }
    });

    this.savematerial(this.mybasketmaterial)
    this.enablecheckout();
    this.checkplacebtn();
    this.cd.detectChanges();
   
  }

  enablecheckout(){
    this.showbtnenabled = this.mybasketmaterial.length > 0 ? false : true; 

  }
  

/*   onQuantityChange(element: any, input: any) {
    input.value = input.value.includes('.')
      ? input.value.replace('.', '')
      : input.value;
    this.showbtnenabled = false;
    const i = this.materialReviewList.findIndex(
      (e: any) => e.title === element.h2content
    );
    if (i > -1) {
      this.materialReviewList.splice(i, 1);
    }
    if (input.value) {
      element.quantity = input.value;
      this.materialReviewList.push({
        image: element.media,
        title: element.h2content,
        quantity: element.quantity,
        materialID: element.materialCode,
      });
    }

    this.materialReviewList.forEach((ele) => {
      if (parseFloat(ele.quantity) > 10) {
        this.showbtnenabled = true;
      }
    });
  } */

  getFormControl(control: string) {
    return this.addressForm!.get(control);
  }

  getImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image?.url;
  }

  getpdf(pdf: any): string {
    return this.config.backend?.occ?.baseUrl + pdf;
  }

  toggleinput(element?: any) {
    //this.showinput=true;
    element.displayAdd = true;
  }

  onfocusout(element: any) {
    element.displayAdd = element.quantity == '' ? false : true;
  }
  movetoreview() {
    //document.body.scrollTop = 500;
    document.documentElement.scrollTop = 500;
    this.showmateriallanding = false;
    this.showreview = true;
    this.showback = true;
    this.showthankyou = false;
    //this.enableSubmit = !this.invalidValue && this.materialReviewList.length > 0 ? true : false;
    this.checkdigitalMaterial();
    this.checkplacebtn();
    this.cd.detectChanges();
  }
  backtolanding() {
    this.showmateriallanding = true;
    this.showreview = false;
    this.showback = false;
    this.showthankyou = false;
    this.scrollToTop();
    this.showbtnenabled = this.mybasketmaterial.length > 0 ? false : true;
  }
  displayAddress() {
    this.displayAddressForm = !this.displayAddressForm;
    setTimeout(()=> {
      this.setFetchify();
    },100)
  }

  ngAfterViewInit(): void {
    if(!this.cc){
      //this.cc = this.registrationUkService.fetchifyCallUK();
      this.cc = new clickToAddress({
        accessToken: '7669a-89946-0db5f-06dae',
        countryMatchWith: 'text',
        enabledCountries: ['United Kingdom'],
        domMode: 'id',
        gfxMode: 1,
        style: {
          ambient: 'light', // Use white as main interface color
          accent: 'default', // Use default secondary color for interface
        },
        texts: {
          default_placeholder: 'Start with post/zip code or street',
        },
        showLogo: true,
        disableAutoSearch: false,
      });
    }
  }

  setFetchify(){
    this.cc.attach(
      {
        search: 'address',
        town: 'city',
        postcode: 'code',
        line_1: 'line1',
        country: 'country'
      },
      {
        onResultSelected: (c2a: any, elements: any, address: any) => {
          this.addressForm.controls['line1']?.setValue(address.line_1);
          this.addressForm.get('line1')?.markAsTouched();
          this.addressForm.controls['city']?.setValue(address.locality);
          this.addressForm.get('city')?.markAsTouched();
          this.addressForm.controls['code']?.setValue(address.postal_code);
          this.addressForm.get('code')?.markAsTouched();
          this.addressForm.controls['country']?.setValue(address.country_name);
          this.addressForm.get('country')?.markAsTouched();
          this.addressForm.updateValueAndValidity();
          this.cd.detectChanges();
        },
      }
    );
  }

  removeMaterials() {
    this.mybasketmaterial.forEach((material:any)=>{
      material.quantity=null
    })
    this.mybasketmaterial = [];
    this.hasdigital=false;
    this.enableSubmit = this.mybasketmaterial.length > 0 ? true : false;
    this.savematerial(this.mybasketmaterial)
  }
  checkdigitalMaterial(){
   this.hasdigital= this.mybasketmaterial.find((digital:any)=>
      digital.tileType=='DIGITAL_MATERIAL'
    )
    this.cd.detectChanges();
  }
  rowSelected(row: any) {

    const location=this.data.find((data:any)=>data.locationId==row.locationId);
    if(location){
      if(location.checked && location.selected){
        location.checked=false;
        location.selected=false;
      }else{
        location.checked=true;
        location.selected=true;
      }
    }
  

    this.dataSource.data = this.data;

    if(this.hasdigital){
      if(this.digitalcheck){
        const rowcheck=this.data.find((row:any)=>row.checked==true)
        if(rowcheck){
        this.enableSubmit = this.mybasketmaterial.length > 0 ? true : false;
        }else{
          this.enableSubmit=false
        }
      }else{
        this.enableSubmit=false
      }
    } else{
      const rowcheck=this.data.find((row:any)=>row.checked==true)
      if(rowcheck){
      this.enableSubmit = this.mybasketmaterial.length > 0 ? true : false;
      }else{
        this.enableSubmit=false
      }
    }  
  }

  submitMaterials() {
    this.isLoading=true;
   /*  this.showreview = false;
    this.showback = false;
    this.showthankyou = true; */
    const selectedAddress = this.dataSource.data.filter(
      (ele: any) => ele.checked
    );
   /*  const productsList = this.mybasketmaterial.map((ele:any) => {
      return {
        materialID: ele.code,
        qty: ele.quantity,
      };
    }); */
    const requestData = {
      //productDetails: productsList,
      soldToID: this.selectedAccount,
      customerAddress: selectedAddress.map((location: any) => ({
        shipToId: location.locationId,
        company: location.shippingOrganizationName,
        line1: location.shippingAddressLine1,
        line2: location.shippingAddressLine2,
        town: location.town,
        postalCode: location.postalCode,
        country: ''
      })),
    };

    this.requestNumber =
      this.materialsUKService.submitMaterialData(requestData).subscribe((res:any)=>{
        this.isLoading=false;
        this.showreview = false;
        this.showback = false;
        this.showthankyou = true;
        this.scrollToTop();
        this.downloaddigital=[];
        this.mybasketmaterial.forEach((element:any) => {
          if(element.tileType=="DIGITAL_MATERIAL"){
            this.downloaddigital.push(element);
          } 
          });
          this.cd.detectChanges();
      }, (error) => {
        console.log('error: ', error);
        this.isLoading = false;
        this.cd.detectChanges();
      }
    );
    this.dataSource.data = [...selectedAddress];
  }

  onSubmit() {
    this.isSubmitted = true;
    if (this.addressForm.invalid) {
      return;
    }
    this.count++;
    this.displayAddress();
    const newAddress = {
      checked: true,
      shippingOrganizationName:
        this.addressForm.controls.organizationName.value,
      shippingAddressLine1: this.addressForm.controls.line1.value,
      town: this.addressForm.controls.city.value,
      postalCode: this.addressForm.controls.code.value,
      selected: true,
      locationId:'00000'+this.count,
    };

    this.data.push(newAddress);
   /*  const data = this.data.map((data: any) => {
      data.checked =
        newAddress.locationId != data.locationId
          ? false
          : true;
      data.selected =
        newAddress.locationId == data.locationId
          ? false
          : true;
      return data;
    }); */

    this.dataSource.data = this.data;

    if(this.hasdigital){
      if(this.digitalcheck){
        this.enableSubmit = this.mybasketmaterial.length > 0 ? true : false;
      }else{
        this.enableSubmit=false
      }
    } else{
      this.enableSubmit = this.mybasketmaterial.length > 0 ? true : false;
    }
    this.addressForm.reset();
    this.isSubmitted=false;
    this.cd.detectChanges();
  }
  handleoncheck(event:any){
    
    if (event.target.checked) {
      this.digitalcheck=true;
   
      const rowcheck=this.data.find((row:any)=>row.checked==true)
      if(rowcheck){
      this.enableSubmit = this.mybasketmaterial.length > 0 ? true : false;
      }else{
        this.enableSubmit=false;
      }
    }else{
      this.digitalcheck=false;
      this.enableSubmit=false;
    }
    this.cd.detectChanges();
  }
getsavematerial(){
  this.materialsUKService.getsavematerial().subscribe((res:any)=>{
    res?.forEach((element:any) => {
     
      element.maxqunatitynumber=Number(element.maxQty);
    });
      
    this.mybasketmaterial=res;
    this.enablecheckout();
  });
}
  checkplacebtn(){
    if(this.hasdigital){

      if(this.digitalcheck){
        const rowcheck=this.data.find((row:any)=>row.checked==true)
        if(rowcheck){
        this.enableSubmit = this.mybasketmaterial.length > 0 ? true : false;
        }else{
          this.enableSubmit=false;
        }
      }else{
        this.enableSubmit=false;
      }

    } else{

      const rowcheck=this.data.find((row:any)=>row.checked==true)
        if(rowcheck){
        this.enableSubmit = this.mybasketmaterial.length > 0 ? true : false;
        }else{
          this.enableSubmit=false;
        }
    }

  }

 /*  reviewQuantityChange(material: any, input: any) {
    input.value = input.value.includes('.')
      ? input.value.replace('.', '')
      : input.value;
    this.materialReviewList = this.materialReviewList
      .map((ele) => {
        if (ele.title == material.title) {
          ele.quantity = input.value;
        }
        ele.quantityInvalid = ele.quantity > 10 ? true : false;
        return ele;
      })
      .filter(
        (ele) => !isNaN(parseInt(ele.quantity)) && parseInt(ele.quantity) > 0
      );

    this.invalidValue = input.value > 10 ? true : false;
  }
 */
 
  downloadpdf(downloadlink:string){
    return this.config.backend?.occ?.baseUrl + downloadlink + "&attachment=true";
  }
  scrollToTop(): void {
    window.scrollTo({ top: 300, behavior: 'smooth' });
  }


  /* async filedownload(){
    const fileUrls = [
      'https://api.caah8q6d5y-seqirusuk1-d3-public.model-t.cc.commerce.ondemand.com/medias/Disease-Awareness-Flu-Staff-Pin-Badges?context=bWFzdGVyfHJvb3R8MTM5NzR8YXBwbGljYXRpb24vcGRmfGFHUmhMMmhqWkM4NE9USXlNek0yTURBeU1EYzRMMFJwYzJWaGMyVXRRWGRoY21WdVpYTnpMVVpzZFMxVGRHRm1aaTFRYVc0dFFtRmtaMlZ6fGMzNjAwYTAzZDdmNDNmMjkyMmMxNWFjZjY3NmQxYTRhYzhjZjgyNDY4M2UyZGRiYWI2Y2VhNzZiOTA4ZjNiZDA',
      'https://api.caah8q6d5y-seqirusuk1-d3-public.model-t.cc.commerce.ondemand.com/medias/Flu-vaccination-uptake-campaign-posters?context=bWFzdGVyfHJvb3R8NzE4Nzg2OXxhcHBsaWNhdGlvbi96aXB8YUdNd0wyaGtPQzg0T1RJeU16TTJNell5TlRJMkwwWnNkUzEyWVdOamFXNWhkR2x2YmkxMWNIUmhhMlV0WTJGdGNHRnBaMjR0Y0c5emRHVnljd3xmNmFhYmU1NTExOGNmZmQyYjliZjBiYTk4NjdkYTFmMzMyMmIyYTJlYzg3MTRjZmVlMDE5NTg3NGYyNTk2MGY3'
    ];
    const zip = new JSZip();

    for (const url of fileUrls) {
      const fileName = url.split('/').pop() || 'file';
      const fileData = await this.http.get(url, { responseType: 'blob' }).toPromise() ;
      if(fileData){
      zip.file(fileName, fileData);
      }
    }

    zip.generateAsync({ type: 'blob' }).then(content => {
      saveAs(content, 'downloaded-files.zip');
    });

  } */
    filedownload(){
      let downloadurl="";
      let stringcomponent="Digi"
       if(this.downloaddigital?.length>1){

        this.downloaddigital.sort((a:any, b:any) => a?.sequenceNumber - b?.sequenceNumber);

        this.downloaddigital.forEach((dig:any)=>{
        stringcomponent=stringcomponent.concat("-"+dig?.sequenceNumber)
        });
        this.materialsUKService.getlink(stringcomponent).subscribe((dataurl:any) => {
          downloadurl=dataurl?.media?.url;
          downloadurl=this.config.backend?.occ?.baseUrl + downloadurl + "&attachment=true";
          window.open(downloadurl, '_blank');
          this.cd.detectChanges();
        });

       }
       else{
        downloadurl=this.config.backend?.occ?.baseUrl + this.downloaddigital[0]?.downloadedMedia?.url + "&attachment=true";
        window.open(downloadurl, '_blank');

       }

    }

    ngOnDestroy(){
      this.mybasketmaterial=[];
      //destroying the sliders at the last
      this.generalSwiper?.destroy();
      this.hcpSwiper?.destroy();
      this.digitalSwiper?.destroy();
    }
    
    private initSliders(): void {
      const baseConfig: any = {
        modules: [Navigation],
        slidesPerView: 3.5,
        centeredSlides: true, // ← centers active slide (gives side peeks)
        centeredSlidesBounds: true, // ← flush at first & last (no overflow)
        slidesPerGroup: 1, // ← move one slide at a time
        spaceBetween: 24,
        breakpoints: {
          1400: { spaceBetween: 32 },
        },
      };
      //checking generalslider exisits and prevents reinitalising the general slider
      if (this.generalSliderRef?.nativeElement && !this.generalSwiper) {
        //creating the swiper instance
        this.generalSwiper = new Swiper(this.generalSliderRef.nativeElement, {
          ...baseConfig,
          navigation: {
            prevEl: this.generalPrevRef?.nativeElement,
            nextEl: this.generalNextRef?.nativeElement,
          },
        });
      }
      //checking hcpSlider exists and prevents reinitalising the hcp slider
      if (this.hcpSliderRef?.nativeElement && !this.hcpSwiper) {
        this.hcpSwiper = new Swiper(this.hcpSliderRef.nativeElement, {
          ...baseConfig,
          navigation: {
            prevEl: this.hcpPrevRef?.nativeElement,
            nextEl: this.hcpNextRef?.nativeElement,
          },
        });
      }
     //checking digitalSlider exists and prevents reinitalising the digital slider
      if (this.digitalSliderRef?.nativeElement && !this.digitalSwiper) {
        this.digitalSwiper = new Swiper(this.digitalSliderRef.nativeElement, {
          ...baseConfig,
          navigation: {
            prevEl: this.digitalPrevRef?.nativeElement,
            nextEl: this.digitalNextRef?.nativeElement,
          },
        });
      }
    }
    downloaddigitalmaterial(element: any) {
      this.selectedDigitalMaterial = element;
      this.digitalAgreeChecked = false; 
      this.opendigital = true;
      this.cd.detectChanges();
    }
  closedigital() {
    this.opendigital = false;
    this.selectedDigitalMaterial = null;
    this.digitalAgreeChecked = false;
    this.cd.detectChanges();
  }
  onDigitalAgreeChange(event: any) {
    this.digitalAgreeChecked = event.target.checked;
    this.cd.detectChanges();
  }
  continueDigitalDownload() {
    if (!this.digitalAgreeChecked || !this.selectedDigitalMaterial) {
      return;
    }

    const downloadUrl =
      this.config.backend?.occ?.baseUrl +
      this.selectedDigitalMaterial.downloadedMedia?.url +
      "&attachment=true";

    window.open(downloadUrl, '_self');
    this.closedigital();
  }
}

